interface ComparableLayerState {
  filter?: unknown;
  hidden: boolean;
  hiddenTypes: string[];
}

const areStringArraysEqual = (a: string[], b: string[]) =>
  a.length === b.length && a.every((value, index) => value === b[index]);

export const areLayersEqual = (
  prev: Record<string, ComparableLayerState>,
  next: Record<string, ComparableLayerState>,
) => {
  const prevKeys = Object.keys(prev);
  const nextKeys = Object.keys(next);
  if (prevKeys.length !== nextKeys.length) return false;

  return nextKeys.every((key) => {
    const prevLayer = prev[key];
    const nextLayer = next[key];
    if (!prevLayer || !nextLayer) return false;

    return (
      prevLayer.hidden === nextLayer.hidden &&
      prevLayer.filter === nextLayer.filter &&
      areStringArraysEqual(prevLayer.hiddenTypes, nextLayer.hiddenTypes)
    );
  });
};
